import React from 'react';
import {connect} from 'react-redux';
import ReviewsSectionEditPopup from './reviews_section_edit';
import {
    addReviewsToSite, removeReviewsForSite, sortSelectedReviews,
    updateTitleFieldInTheSectionEditPopup,
    updateBodyFieldInTheSectionEditPopup,
} from '../../sections/actions';
import {closeReviewsSectionPopup, updateReviewsSectionContents} from '../../actions';
import {clearReviewsSearchFilter} from '../../../reviews/actions';
import {onSearchReviews} from '../../thunks';

class ReviewsPopup extends React.Component {
    
    render() {
        return (
            <ReviewsSectionEditPopup
                open={this.props.reviewsSectionEditOpen}
                pageId={this.props.pageId}
                reviews={this.props.reviews}
                selectedReviews={this.props.selectedReviews}
                loading={this.props.loading}
                title={this.props.reviewsSectionTitle}
                body={this.props.reviewsSectionBody}
                onUpdateTitleField={
                    title => this.props.updateReviewsSectionTitleField(title)
                }
                onUpdateBodyField={
                    body => this.props.updateReviewsSectionBodyField(body)
                }
                onHandleSubmit={() => {
                    this.props.updateReviewsSectionContents(
                        this.props.pageId,
                        this.props.reviewsSectionId,
                        this.props.sectionData,
                        this.props.selectedSettings
                    );
                    this.props.clearReviewsSearchFilter();
                }}
                onHandleClose={() => {
                    this.props.closeReviewsSectionPopup();
                    this.props.clearReviewsSearchFilter();
                }}
                searchCriteria={this.props.reviewSearchCriteria}
                onSearchReviews={this.props.onSearchReviews}
                addReviewsToSite={this.props.addReviewsToSite}
                removeReviewsForSite={this.props.removeReviewsForSite}
                onSelectedReviewsSort={this.props.sortSelectedReviews}
            />
        )
    }
}

const mapStateToProps = state => ({
    sectionData: state.pageBuilderSectionPopup.data,
    selectedSettings: state.pageBuilderSectionPopup.settings,
    reviewsSectionEditOpen: state.pageBuilder.reviewsSectionPopup.open,
    reviewsSectionTitle: state.pageBuilderSectionPopup.data.title,
    reviewsSectionBody: state.pageBuilderSectionPopup.data.body,
    reviewsSectionId: state.pageBuilderSectionPopup.sectionId,
    reviewSearchCriteria: state.reviews.reviewSearchCriteria,
    reviews: state.reviews.allReviewsBySearchTerms,
    selectedReviews: state.pageBuilderSectionPopup.data.reviews,
    loading: state.layout.ajaxCallsInProgress > 0,
});

export default connect(
    mapStateToProps, {
        updateReviewsSectionTitleField: updateTitleFieldInTheSectionEditPopup,
        updateReviewsSectionBodyField: updateBodyFieldInTheSectionEditPopup,
        updateReviewsSectionContents: updateReviewsSectionContents,
        closeReviewsSectionPopup: closeReviewsSectionPopup,
        onSearchReviews: onSearchReviews,
        clearReviewsSearchFilter: clearReviewsSearchFilter,
        addReviewsToSite: addReviewsToSite,
        removeReviewsForSite: removeReviewsForSite,
        sortSelectedReviews: sortSelectedReviews
    }
)(ReviewsPopup);


// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/reviews_popup.js